import { BLOCK_ZIP_CODE_LIST_ITEMS_KEY } from '@/components/content/CheckOutV2/constants';

export const getBlockZipCodeItemsList = (currentStoreId: string) => {
	if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
		try {
			const value = localStorage.getItem(BLOCK_ZIP_CODE_LIST_ITEMS_KEY) ?? undefined;
			if (value) {
				const data = value.split('-');
				if (data[0] !== currentStoreId) {
					localStorage.removeItem(BLOCK_ZIP_CODE_LIST_ITEMS_KEY);
					return undefined;
				}
				return data[1];
			}
		} catch (e) {
			return undefined;
		}
	}
	return undefined;
};

export const countPaintRowsColor = (colorCodes?: string): number => {
	if (!colorCodes || typeof colorCodes !== 'string') return 0;

	return colorCodes
		.split(',')
		.map((row) => row.trim())
		.filter((row) => row.length > 0).length;
};

export const sortBySelected = (
	array: any,
	selectedId: string,
	key = 'storeName',
	idKey = 'stLocId'
) =>
	array.sort((a: any, b: any) => {
		if (a[idKey] === selectedId) return -1;
		if (b[idKey] === selectedId) return 1;
		return a[key].localeCompare(b[key]);
	});
